import styled from 'styled-components'

export const HeaderBox = styled.section`
  border-bottom: 1px solid ${p => p.theme.grey10};
  padding: 0px 30px 25px 30px;
`

export const IconHeading = styled.h3`
  margin: 0 0 10px;
  font-size: ${p => p.theme.fontSizeL};
  align-items: center;
  display: flex;
  line-height: 1;
  svg {
    margin: 0 10px 0 0;
    color: ${p => p.theme.grey50};
  }
`

export const ConstrainWidth = styled.div`
  max-width: 450px;
`
